<ngx-bootstrap-multiselect
    [settings]="settings"
    [texts]="texts"
    [options]="options"
    [(ngModel)]="idsClientesGruposEconomicos"
    (ngModelChange)="onChange()"
    [disabled]="disabled">
</ngx-bootstrap-multiselect>